var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense, useEffect, useMemo, useState } from "react";
import { Flex } from "antd";
import HeaderTabs from "./../../components/tabComponents/HeaderTabs.js";
import FavoritesHeader from "./favoritesHeader/FavoritesHeader";
import Loader from "./../../components/loader/Loader.js";
import { Components } from "./favoritesContent/favoritesContentService";
import { withScrollToTop } from "./../../hoc";
import { useSearchParams } from "react-router-dom";
import { FAVORITE_TABS } from "./favoritesService";
import { useTranslation } from "@inscore/shared";
const Favorites = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabKeyByUrl = useMemo(
    () => searchParams.get("t"),
    [searchParams]
  );
  const [activeTabKey, setActiveTabKey] = useState(
    activeTabKeyByUrl || "Matches"
  );
  const [updateContent, setUpdateContent] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    setActiveTabKey(activeTabKeyByUrl || "Matches");
  }, [activeTabKeyByUrl]);
  const handleSetActiveTabKey = (key) => {
    setActiveTabKey(key);
    const next = new URLSearchParams();
    key && next.set("t", key);
    setSearchParams(next);
  };
  const Component = useMemo(
    () => {
      var _a;
      return (_a = Components[activeTabKey]) != null ? _a : Loader;
    },
    [activeTabKey]
  );
  const forceUpdateContent = () => {
    setUpdateContent(true);
    setTimeout(() => setUpdateContent(false), 100);
  };
  return /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 24, style: { position: "relative" }, children: [
    /* @__PURE__ */ jsx(FavoritesHeader, { onFavoriteToggle: forceUpdateContent, children: /* @__PURE__ */ jsx(
      HeaderTabs,
      {
        items: FAVORITE_TABS.map((i) => __spreadProps(__spreadValues({}, i), {
          label: t(i.label.toLowerCase())
        })),
        activeTabKey,
        setActiveTabKey: handleSetActiveTabKey
      }
    ) }),
    /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, {}), children: /* @__PURE__ */ jsx(Component, { updateContent }) })
  ] });
};
var stdin_default = withScrollToTop(Favorites);
export {
  stdin_default as default
};
